import { render, staticRenderFns } from "./CheckoutModalHandraiserWarning.vue?vue&type=template&id=452d79f1&scoped=true"
import script from "./CheckoutModalHandraiserWarning.vue?vue&type=script&lang=js"
export * from "./CheckoutModalHandraiserWarning.vue?vue&type=script&lang=js"
import style0 from "./CheckoutModalHandraiserWarning.vue?vue&type=style&index=0&id=452d79f1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452d79f1",
  null
  
)

export default component.exports